import { render } from "./SelectListButtons.vue?vue&type=template&id=0732edbc"
import script from "./SelectListButtons.vue?vue&type=script&lang=js"
export * from "./SelectListButtons.vue?vue&type=script&lang=js"
script.render = render

export default script